import React from 'react';
import styled from 'styled-components';

const BalanceUSDContainer = styled.div`
  margin-top: 4px;
  font-size: 0.75rem;
  color: var(--text-secondary);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  transition: color 0.3s ease;
`;

const USDValue = styled.span`
  font-weight: 600;
  color: var(--text-primary);
  transition: color 0.3s ease;
`;

interface BalanceUSDProps {
  quoteBalance: number;
  tokenBalance: number;
  quoteSymbol: string;
  tokenSymbol: string;
  quotePrice: number;
  tokenPrice: number;
  isPriceLoading: boolean;
}

const BalanceUSD: React.FC<BalanceUSDProps> = ({
  quoteBalance,
  tokenBalance,
  quoteSymbol,
  tokenSymbol,
  quotePrice,
  tokenPrice,
  isPriceLoading
}) => {
  // Для USDC цена всегда 1
  const actualQuotePrice = quoteSymbol === 'USDC' || quoteSymbol === 'USDbC' ? 1 : quotePrice;
  const quoteUSD = quoteBalance * actualQuotePrice;
  
  // Валидация цены токена - если цена подозрительно высокая (больше 10x от ETH), показываем предупреждение
  const MAX_REASONABLE_TOKEN_PRICE = Math.max(quotePrice * 10, 10000);
  const isPriceSuspicious = tokenPrice <= 0 || tokenPrice > MAX_REASONABLE_TOKEN_PRICE;
  
  // Если цена невалидна, не показываем USD стоимость токена
  const tokenUSD = isPriceSuspicious ? 0 : (tokenBalance * tokenPrice);
  const totalUSD = quoteUSD + tokenUSD;

  if (isPriceLoading) {
    return (
      <BalanceUSDContainer>
        <span style={{ color: 'var(--text-muted)' }}>Loading USD values...</span>
      </BalanceUSDContainer>
    );
  }

  return (
    <>
      {isPriceSuspicious && (
        <div style={{ 
          marginTop: '8px', 
          padding: '8px', 
          background: 'rgba(255, 152, 0, 0.1)', 
          border: '1px solid rgba(255, 152, 0, 0.3)',
          borderRadius: '6px',
          fontSize: '0.75rem',
          color: '#ff9800',
          textAlign: 'center'
        }}>
          ⚠️ Цена токена выглядит подозрительно ({tokenPrice > MAX_REASONABLE_TOKEN_PRICE ? `слишком высокая: $${tokenPrice.toFixed(6)}` : 'невалидная'}). USD баланс токена скрыт.
        </div>
      )}
      <BalanceUSDContainer>
        <span>
          {quoteSymbol}: <USDValue>${quoteUSD.toFixed(2)}</USDValue>
        </span>
        {!isPriceSuspicious && (
          <span>
            {tokenSymbol}: <USDValue>${tokenUSD.toFixed(2)}</USDValue>
          </span>
        )}
        {isPriceSuspicious && (
          <span style={{ color: 'var(--text-muted)' }}>
            {tokenSymbol}: <span style={{ fontStyle: 'italic' }}>недоступно</span>
          </span>
        )}
        <span style={{ fontWeight: '600', color: 'var(--success)' }}>
          Total: <USDValue>${totalUSD.toFixed(2)}</USDValue>
        </span>
      </BalanceUSDContainer>
    </>
  );
};

export default BalanceUSD;
